import React, { Component } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "../../../components/admin/css/common.css";
import {sweetStatusAlert} from "../../../components/common/SweetAlert.js";
import Spinner from "react-bootstrap/Spinner";
import PageSpinner from "../../../components/common/spinner/PageSpinner.js";
import moment from "moment";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Checkbox,
  Autocomplete,
  TextField
} from "@mui/material";
import MaterialCustomTablePagination from "../../../components/common/MaterialCustomTablePagination.js";
import debounce from "lodash.debounce";
import SimpleReactValidator from "simple-react-validator";
import { libraryService } from "../../../service/question/libraryService.js";
import { createService } from "../../../service/question/createService.js";
import ContentWrapper from "../../../components/common/ContentWrapper.js";
import config from '../../../helper/config.js';
import {customerConstants} from "../../../helper/constants.js";
import { QUESTION_SETTINGS_FILTERS } from "../../../helper/constants.js";
import { CMC_QUESTION_SETTINGS_FILTERS } from "../../../helper/constants.js";
import ModalBody from "../../../components/common/modal/ModalBody";
import ModalHeader from "../../../components/common/modal/ModalHeader";
import ViewForm from "../../../components/common/form/Form";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import {Box, Chip, CircularProgress, IconButton} from "@mui/material";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FormControlLabel from "@mui/material/FormControlLabel";
import PaperListChips from "../../manage/paper/edsider/FindPaperTabs/PaperListChips.js";
import Tooltip from "@mui/material/Tooltip";
import ClearIcon from '@mui/icons-material/Clear';
import ChevronLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ChevronRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import PaperFilterLayout from "../../manage/paper/edsider/TheFilter/PaperFilterLayout.js";
import { EMPLOYEE_FILTERS } from "../../../helper/constants.js";
import StickyCardBody from "../../../components/common/StickyCardBody.js";



const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle, privilegeEditEnabled, gradeText, isCMC, FILTERS;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    gradeText = "Grade";
    isCMC = false;
    FILTERS = QUESTION_SETTINGS_FILTERS;
    privilegeEditEnabled = false;
    break;
  case customerConstants.EXO_CUSTOMER2:
    gradeText = "Year";
    isCMC = true;
    FILTERS = CMC_QUESTION_SETTINGS_FILTERS;
    privilegeEditEnabled = false;
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent",
    };
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent",
    };
    break;
  default:
    gradeText = "Grade";
    isCMC = false;
    FILTERS = QUESTION_SETTINGS_FILTERS;
    privilegeEditEnabled = true;
    break;
}

export default class extends Component {
  constructor(props) {
    super(props);
    this.createValidationsInstance();
    this.state = {
      questions: [],
      limit: 300, 
      offset: 0, 
      search_term: "",
      sort_column: "created_at",
      sort_direction: "DESC",
      selectedCategories: null,
      selectedAuthors: null,
      selectedSources: null, 
      selectedChapters: null,
      selectedGrades: null,
      selectedDifficulties: null,
      selectedLanguages: null,
      selectedTerms: null,
      selectedYears: null,
      selectedTypes: null,
      selectedsubjects: null,
      selectedTeachers: null,
      teachers: [],
      checked: false,
      totalCount: 300,
      totalRealCount: 0,
      gradeCounts: [],
      subjectCounts: [],
      languageCounts: [],
      authorCounts: [],
      categoryCounts: [],
      difficultyCounts: [],
      chapterCounts: [],
      yearCounts: [],
      termCounts: [],
      typeCounts: [],
      sourceCounts: [],
      createdByCounts: [],
      isTableDataLoading: true,
      currentPage: 0,
      isLoading: false,
      allCategories: [],
      allLanguages: [],
      allSubjects: [],
      allAuthors: [],
      allSources: [],
      allYears: [],
      allTypes: [],
      allDifficulties: [],
      allGrades: [],
      allTerms: [],
      allChapters: [],
      allPrivileges: [],
      allCreators: [],
      selectSearchTerm: "",
      selectedQuestions: [],
      selectedQuestion: "",
      selectAll: false,
      filterValues: [],
      filters: [],
      selectedFilters: [],
      editTitle: null,
      editCategoryId: null,
      editGradeId: null,
      editLanguageId: null,
      editSubjectId: null,
      editChapterId: null,
      editDifficultyId: null,
      editAuthorId: null,
      editSourceId: null,
      editYearId: null,
      editTermId: null,
      editPrivilegeId: null,
      selectedStartDate: null,
      selectedEndDate: null,
    };

    // Debounced version of handleSearch function
    this.debouncedHandleSearch = debounce(this.fetchAllQuestions, 3000);
  }

  // Reset the form fields to initail values on update, insert, edit modal close and add modal close
  resetFormFields = () => {
    this.setState({
      editTitle: null,
      editCategoryId: null,
      editGradeId: null,
      editLanguageId: null,
      editSubjectId: null,
      editChapterId: null,
      editDifficultyId: null,
      editAuthorId: null,
      editSourceId: null,
      editYearId: null,
      editTermId: null,
      editPrivilegeId: null,
    });
  };

  async componentDidMount() {
    this.setState({isTableDataLoading: true});
    await this.fetchAllQuestionMetaData();
    await this.fetchAllQuestions();
    this.setState({isTableDataLoading: false});
  }

  // Creating validator instance
  createValidationsInstance() {
    this.validator = new SimpleReactValidator({
      validators: {
        customMin: {
          message: "The :attribute value must be greater than :min.",
          rule: (val, params) => {
            return parseInt(val, 10) > params[0];
          },
          messageReplace: (message, params) => message.replace(':min', params[0]),
          required: true
        }
      }
    });
  }

  fetchAllQuestionMetaData  = async () => {
    const fetchQuestionMetaData =
      await createService.getAllQuestionMetaData();

    await Promise.all([fetchQuestionMetaData])
      .then((response) => {
        const [questionMetaDataResponse] = response;

        this.setState({
          allCategories: questionMetaDataResponse.data.find(
            (item) => "categories" in item
          ).categories,
          allLanguages: questionMetaDataResponse.data.find(
            (item) => "languages" in item
          ).languages,
          allTypes: questionMetaDataResponse.data.find(
            (item) => "types" in item
          ).types,
          allSubjects: questionMetaDataResponse.data.find(
            (item) => "subjects" in item
          ).subjects,
          allAuthors: questionMetaDataResponse.data.find(
            (item) => "authors" in item
          ).authors,
          allSources: questionMetaDataResponse.data.find(
            (item) => "sources" in item
          ).sources,
          allYears: questionMetaDataResponse.data.find(
            (item) => "years" in item
          ).years,
          allDifficulties: questionMetaDataResponse.data.find(
            (item) => "difficulty_types" in item
          ).difficulty_types,
          allGrades: questionMetaDataResponse.data.find(
            (item) => "grades" in item
          ).grades,
          allTerms: questionMetaDataResponse.data.find(
            (item) => "terms" in item
          ).terms,
          allChapters: questionMetaDataResponse.data.find(
            (item) => "chapters" in item
          ).chapters,
          allPrivileges: questionMetaDataResponse.data.find(
            (item) => "privileges" in item
          ).privileges,
          allCreators: questionMetaDataResponse.data.find(
            (item) => "creators" in item
          ).creators
        });
      })
      .catch((error) => {
        this.setState({
          isTableDataLoading: false,
        });
      });
  }

  getQuestionCategory(category_id) {
    if (category_id !== null) {
        const category = this.state.allCategories?.find(
            (category) => category.category_id == category_id
        );
        return category?.name;
    }
    else{
        return "N/A";
    }
  }

  getQuestionLanguage(language_id) {
    if (language_id !== null) {
        const language = this.state.allLanguages?.find(
            (language) => language.language_id == language_id
        );
        return language?.language;
    }
    else{
        return "N/A";
    }
  }

  getQuestionSubject(subject_id) {
    if (subject_id !== null) {
        const subject = this.state.allSubjects?.find(
            (subject) => subject.subject_id == subject_id
        );
        return subject?.subject;
    }
    else{
        return "N/A";
    }
  }

  getQuestionType(type_id, is_subquestion) {
    if (type_id !== null) {
        const type = this.state.allTypes?.find(
            (type) => type.type_id == type_id
        );
        if(type_id == 5){
            if(is_subquestion){
                return type?.qtype + " (Sub Question)";
            }
            else{
                return type?.qtype + " (Main Question)";
            }
        }
        else{
            return type?.qtype;
        }
    }
    else{
        return "N/A";
    }
  }

  getQuestionAuthor(author_id) {
    if (author_id !== null) {
        const author = this.state.allAuthors?.find(
            (author) => author.author_id == author_id
        );
        return author?.author;
    }
    else{
        return "N/A";
    }
  }

  getQuestionSource(source_id) {
    if (source_id !== null) {
        const source = this.state.allSources?.find(
            (source) => source.source_id == source_id
        );
        return source?.source;
    }
    else{
        return "N/A";
    }
  }

  getQuestionYear(year_id) {
    if (year_id !== null) {
        const year = this.state.allYears?.find(
            (year) => year.year_id == year_id
        );
        return year?.year;
    }
    else{
        return "N/A";
    }
  }

  getQuestionDifficulty(difficulty_id) {
    if (difficulty_id !== null) {
        const difficulty = this.state.allDifficulties?.find(
            (difficulty) => difficulty.difficulty_id == difficulty_id
        );
        return difficulty?.difficulty_type;
    }
    else{
        return "N/A";
    }
  }

  getQuestionGrade(grade_id) {
    if (grade_id !== null) {
        const grade = this.state.allGrades?.find(
            (grade) => grade.grade_id == grade_id
        );
        return grade?.grade;
    }
    else{
        return "N/A";
    }
  }

  getQuestionTerm(term_id) {
    if (term_id !== null) {
        const term = this.state.allTerms?.find(
            (term) => term.term_id == term_id
        );
        return term?.term;
    }
    else{
        return "N/A";
    }
  }

  getCreatedAtLocal(time) {
    if(time != null){
        let timeStamp = new Date(time.concat("Z"))
        let d = new Date(timeStamp)
        // let startDate = d.toDateString();
        // let startTime = d.toLocaleTimeString('en-SL');
        let  local = moment(timeStamp).local().format("MMMM Do YYYY hh:mm A")
        return local;
    }
    else{
        return "N/A";
    }
  }

  getQuestionChapter(chapter_id) {
    if (chapter_id !== null) {
        const chapter = this.state.allChapters?.find(
            (chapter) => chapter.chapter_id == chapter_id
        );
        return chapter?.chapter;
    }
    else{
        return "N/A";
    }
  }

  fetchAllQuestions = async () => {
    const { 
        limit,
        offset,
        sort_column,
        sort_direction,
        search_term,
        selectedCategories,
        selectedAuthors,
        selectedChapters,
        selectedGrades,
        selectedDifficulties,
        selectedLanguages,
        selectedTypes,
        selectedTerms,
        selectedYears,
        selectedsubjects,
        selectedSources,
        selectedTeachers,
        selectedStartDate,
        selectedEndDate,
    } = this.state;
    this.setState({ isTableDataLoading: true });
    await libraryService.getAllLibraryQuestions(
        limit,
        offset,
        sort_column,
        sort_direction,
        search_term,
        selectedCategories,
        selectedAuthors,
        selectedChapters,
        selectedGrades,
        selectedDifficulties,
        selectedLanguages,
        selectedTypes,
        selectedTerms,
        selectedYears,
        selectedsubjects,
        selectedSources,
        selectedTeachers,
        selectedStartDate,
        selectedEndDate,
    ).then((response) => {
        if (response.success) {
          this.setState({
            questions: response.data.questions,
            totalCount: parseInt(response.data.total_count),
            totalRealCount: parseInt(response.data.total_real_count),
            teachers: response.data.teachers,
            gradeCounts: response.data.grade_counts,
            subjectCounts: response.data.subject_counts,
            languageCounts: response.data.language_counts,
            authorCounts: response.data.author_counts,
            categoryCounts: response.data.category_counts,
            difficultyCounts: response.data.difficulty_counts,
            chapterCounts: response.data.chapter_counts,
            yearCounts: response.data.year_counts,
            termCounts: response.data.term_counts,
            typeCounts: response.data.type_counts,
            sourceCounts: response.data.source_counts,
            createdByCounts: response.data.created_by_counts,
            teachers: response.data.teachers,
            isTableDataLoading: false
          });
        } else {
          sweetStatusAlert(
            "Failed!",
            "Error fetching all questions. Please refresh the screen!",
            "error"
          );
        }
      })
      .catch((error) => {
        // Handle any error that occurred during the API call
        sweetStatusAlert(
          "Failed!",
          "Error fetching all questions. Please refresh the screen!",
          "error"
        );
      })
      .finally(() => {
        this.setState({ isTableDataLoading: false }); // Set isTableDataLoading to false after data is fetched
      });
  };

  handleSortChange = (sort_column) => {
    // If the same column is clicked, toggle the sort direction
    const { sort_column: currentSortColumn, sort_direction } = this.state;
    const newSortDirection =
      currentSortColumn === sort_column && sort_direction === "ASC"
        ? "DESC"
        : "ASC";

    this.setState(
      {
        sort_column,
        sort_direction: newSortDirection,
        offset: 0, // Reset offset when changing sorting
        currentPage: 0,
        isTableDataLoading: true,
      },
      () => {
       this.fetchAllQuestions();
      }
    );
  };

  // Handle the data fetching as per the offset(page no) changes
  handlePageChange = (event, newPage) => {
    const { limit } = this.state;
    const newOffset = newPage * limit;
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchAllQuestions();
      }
    );
  };

  handlePageOffsetChange = (newOffset, newPage) => {
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage
      },
      () => {
        this.fetchAllQuestions();
      }
    );
  };

  // handle the data fetching as per the data per page limit gets changess
  handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(this.state.offset / newLimit);
    this.setState(
      {
        limit: newLimit,
        offset: newLimit * newPage,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchAllQuestions();
      }
    );
  };

  // handle search text as per the regex validation and search_term , and fetch data as per the debounce
  handleSearch = (event) => {
    const search_term = event.target.value.trim();
    //const regex = /^[\w\s\d@&.,:;!?()\-_/\\[\]{}'"|#*~+=%$^<>]*$/;
    const regex = /^[\p{L}\p{M}\p{N}\p{P}\p{S}\s]*$/u;

    if (search_term === "" || regex.test(search_term)) {
      this.setState(
        {
          search_term,
          isTableDataLoading: true,
          offset: 0,
          currentPage: 0,
          searchError: false,
        },
        () => {
          this.debouncedHandleSearch();
        }
      );
    } else {
      this.setState({ search_term, searchError: true });
    }
  };

       
    //New Multi Filter
    onSelectFilterMulti = (selectedItem) => {    

      const { filterValues } = this.state;

      let updatedFilterValues = [...filterValues];

      const index = updatedFilterValues.findIndex(
      (item) =>
          item.filter === selectedItem.filter &&
          item[`${selectedItem.filter.toLowerCase()}_id`] === selectedItem[`${selectedItem.filter.toLowerCase()}_id`]
      );


      if (index === -1) {

      updatedFilterValues.push(selectedItem);

      } else {

      updatedFilterValues.splice(index, 1);
      }


      this.onSelectFilterMultiProcess(updatedFilterValues);
  };

  onSelectFilterMultiProcess = (filterValues) => {

      const filterMap = {
          Category: [],
          Source: [],
          Difficulty: [],
          Language: [],
          Subject: [],
          Author: [],
          Year: [],
          Term: [],
          Chapter: [],
          Grade: [],
          Type: [],
          Created_By: [],
      };

      filterValues.forEach((val) => {
      const filterType = val.filter;
      if (filterType && filterMap.hasOwnProperty(filterType)) {
          switch (filterType) {
          case "Category":
              filterMap.Category.push(val?.category_id);
              break;
          case "Source":
              filterMap.Source.push(val?.source_id);
              break;
          case "Difficulty":
              filterMap.Difficulty.push(val?.difficulty_id);
              break;
          case "Language":
              filterMap.Language.push(val?.language_id);
              break;
          case "Subject":
              filterMap.Subject.push(val?.subject_id);
              break;
          case "Author":
              filterMap.Author.push(val?.author_id);
              break;
          case "Year":
              filterMap.Year.push(val?.year_id);
              break;
          case "Term":
              filterMap.Term.push(val?.term_id);
              break;
          case "Chapter":
              filterMap.Chapter.push(val?.chapter_id);
              break;
          case "Grade":
              filterMap.Grade.push(val?.grade_id);
              break;
          case "Type":
              filterMap.Type.push(val?.type_id);
              break;
          case "Created_By":
              filterMap.Created_By.push(val?.created_by_id);
              break;
          default:
              break;
          }
      }
      });

      this.setState(
      {
          filterValues,
          selectedAuthors: filterMap.Author.length > 0 ? filterMap.Author : null,
          selectedsubjects: filterMap.Subject.length > 0 ? filterMap.Subject : null,
          selectedChapters: filterMap.Chapter.length > 0 ? filterMap.Chapter : null,
          selectedTerms: filterMap.Term.length > 0 ? filterMap.Term : null,
          selectedCategories: filterMap.Category.length > 0 ? filterMap.Category : null,
          selectedYears: filterMap.Year.length > 0 ? filterMap.Year : null,
          selectedLanguages: filterMap.Language.length > 0 ? filterMap.Language : null,
          selectedDifficulties: filterMap.Difficulty.length > 0 ? filterMap.Difficulty : null,
          selectedGrades: filterMap.Grade.length > 0 ? filterMap.Grade : null,
          selectedTypes: filterMap.Type.length > 0 ? filterMap.Type : null,
          selectedSources: filterMap.Source.length > 0 ? filterMap.Source : null,
          selectedTeachers: filterMap.Created_By.length > 0 ? filterMap.Created_By : null,
      },
      () => {
          this.fetchAllQuestions();
      }
      );
  };

  isParentChecked = (filterType) => {
      const filterValues = this.state.filterValues;
      const childItems = this.getChildItems(filterType);
      return (
      childItems.length > 0 &&
      childItems.every((child) =>
          filterValues.some(
          (selectedItem) =>
              selectedItem.filter === filterType &&
              selectedItem[`${filterType.toLowerCase()}_id`] ===
              child[`${filterType.toLowerCase()}_id`]
          )
      )
      );
  };

  isParentIndeterminate = (filterType) => {
      const filterValues = this.state.filterValues;
      const childItems = this.getChildItems(filterType);
      const selectedCount = childItems.filter((child) =>
      filterValues.some(
          (selectedItem) =>
          selectedItem.filter === filterType &&
          selectedItem[`${filterType.toLowerCase()}_id`] ===
          child[`${filterType.toLowerCase()}_id`]
      )
      ).length;
      return selectedCount > 0 && selectedCount < childItems.length;
  };

  handleParentCheckboxChange = (filterType, filterItems) => {
      const filterValues = [...this.state.filterValues];
      const childItems = filterItems

      const allSelected = this.isParentChecked(filterType);
      

      let updatedFilterValues;
      if (allSelected) {

      updatedFilterValues = filterValues.filter(
          (item) => item.filter !== filterType
      );
      } else {

      const newSelections = childItems.map((child) => ({
          filter: filterType,
          name: child.name,
          [`${filterType.toLowerCase()}_id`]: child[`${filterType.toLowerCase()}_id`],
      }));
      updatedFilterValues = [
          ...filterValues.filter((item) => item.filter !== filterType),
          ...newSelections,
      ];
      }


      this.onSelectFilterMultiProcess(updatedFilterValues);
  };

    handleFilterChange = (newSelectedFilters) => {

    const getOrNull = (key) =>
      newSelectedFilters[key] && newSelectedFilters[key].length > 0
        ? newSelectedFilters[key]
        : null;

    this.setState(
      {
 
    selectedCategories: getOrNull("Category"),
    selectedAuthors: getOrNull("Author"),
    selectedChapters: getOrNull("Chapter"),
    selectedGrades: getOrNull("Grade"),
    selectedDifficulties: getOrNull("Difficulty"),
    selectedLanguages: getOrNull("Language"),
    selectedTerms: getOrNull("Term"),
    selectedYears: getOrNull("Year"),
    selectedsubjects: getOrNull("Subject"),
    selectedStatuses: getOrNull("Status"),
    selectedSources: getOrNull("Source"),
    selectedCreators:getOrNull("Created_By"),
    selectedTypes: getOrNull("Type"),
    selectedStartDate:getOrNull("StartDate"),
    selectedEndDate:getOrNull("EndDate"),

    offset: 0,
    currentPage: 0,
    
   
      },
      () => {
        this.fetchAllQuestions();
      }
    );
  };

  getChildItems = (filterType) => {
      switch (filterType) {
          case "Category":
              return this.state.allCategories || [];
          case "Source":
              return this.state.allSources || [];
          case "Difficulty":
              return this.state.allDifficulties || [];
          case "Language":
              return this.state.allLanguages || [];
          case "Subject":
              return this.state.allSubjects || [];
          case "Author":
              return this.state.allAuthors || [];
          case "Year":
              return this.state.allYears || [];
          case "Grade":
              return this.state.allGrades || [];
          case "Term":
              return this.state.allTerms || [];
          case "Chapter":
              return this.state.allChapters || [];
          case "Type":
              return this.state.allTypes || [];
          case "Created_By":
              return this.state.allCreators || [];
          default:
              return [];
      }
  };

  clearAllFilters = () => {
      this.setState(
      {
          filterValues: [],
          selectedAuthors: null,
          selectedsubjects: null,
          selectedChapters: null,
          selectedTerms: null,
          selectedCategories: null,
          selectedYears: null,
          selectedLanguages: null,
          selectedDifficulties: null,
          selectedTypes: null,
          selectedSources: null,
          selectedGrades: null,
          selectedTeachers: null,
      },
      () => {
          this.fetchAllQuestions();
      }
      );
  };

  handleBulkClose = () => {
    this.setState({
      showUpdateBulkDetailModal: false
    });
    this.validator.hideMessages();
    this.validator.purgeFields();
    this.resetFormFields();
  }

  toggleUpdateBulkquestionModal = () => {
    this.setState((prevState) => ({
      showUpdateBulkDetailModal: !prevState.showUpdateBulkDetailModal,
    }));
  };

  handleViewClick = (questionItem) => {
    this.setState({
      selectedQuestion: questionItem,  
      showDetailModal: true, 
    });
  };
  
  toggleDetailModal = () => {
    this.setState((prevState) => ({
      showDetailModal: !prevState.showDetailModal,
    }));
  };

  handleChangeTitle = (e) => {
    e.preventDefault();
    const editTitle = e.target.value;
    if(editTitle == "" || editTitle.length == 0){
        this.setState({ editTitle: null });
    }
    else{
        this.setState({ editTitle });
    }
  };

  handleChangeCategory = (e) => {
    e.preventDefault();
    const editCategoryId = e.target.value;
    this.setState({ editCategoryId });
  };

  handleChangeGrade = (e) => {
    e.preventDefault();
    const editGradeId = e.target.value;
    this.setState({ editGradeId });
  };

  handleChangeLanguage = (e) => {
    e.preventDefault();
    const editLanguageId = e.target.value;
    this.setState({ editLanguageId });
  };

  handleChangeChapter = (e) => {
    e.preventDefault();
    const editChapterId = e.target.value;
    this.setState({ editChapterId });
  };

  handleChangeSubject = (e) => {
    e.preventDefault();
    const editSubjectId = e.target.value;
    this.setState({ editSubjectId });
  };

  handleChangeDifficulty = (e) => {
    e.preventDefault();
    const editDifficultyId = e.target.value;
    this.setState({ editDifficultyId });
  };

  handleChangeAuthor = (e) => {
    e.preventDefault();
    const editAuthorId = e.target.value;
    this.setState({ editAuthorId });
  };

  handleChangeSource = (e) => {
    e.preventDefault();
    const editSourceId = e.target.value;
    this.setState({ editSourceId });
  };

  handleChangeYear = (e) => {
    e.preventDefault();
    const editYearId = e.target.value;
    this.setState({ editYearId });
  };

  handleChangeTerm = (e) => {
    e.preventDefault();
    const editTermId = e.target.value;
    this.setState({ editTermId });
  };

  handleChangePrivilege = (e) => {
    e.preventDefault();
    const editPrivilegeId = e.target.value;
    this.setState({ editPrivilegeId });
  };

  handleUpdateBulkSubmit = async (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      this.setState({ isLoading: true });

      const questionItem = {
        question_list: this.state.selectedQuestions,
        title: this.state.editTitle,
        category_id: this.state.editCategoryId,
        grade_id: this.state.editGradeId,
        language_id: this.state.editLanguageId,
        chapter_id: this.state.editChapterId,
        subject_id: this.state.editSubjectId,
        difficulty_id: this.state.editDifficultyId,
        author_id: this.state.editAuthorId,
        source_id: this.state.editSourceId, 
        year_id: this.state.editYearId,
        term_id: this.state.editTermId,
        privilege_id: this.state.editPrivilegeId,
      };

      await libraryService.updateAllQuestions(questionItem)
        .then((response) => {
          this.setState({ isLoading: false, selectedQuestions: [], selectAll: false });
          if (response.success) {
            this.setState({ showUpdateBulkDetailModal: false });
            sweetStatusAlert(
              "Success!",
              "Selected questions updated successfully!",
              "success"
            );
            this.validator.hideMessages();
            this.validator.purgeFields();
            this.resetFormFields();
            this.fetchAllQuestions();
          } else {
            sweetStatusAlert("Failed!", response.message, "error");
          }
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          sweetStatusAlert(
            "Failed !",
            "Unable to update the Selected questions!",
            "error"
          );
        });
    }
  };

 handleSelect = (question_id, sub_questions) => {
    this.setState((prevState) => {
      const { selectedQuestions } = prevState;
  
      let questionIdsToAdd = [question_id];
  
      if (sub_questions !== null) {
        const subQuestionIds = sub_questions.split(",").map((id) => parseInt(id.trim())); 
        questionIdsToAdd = [...questionIdsToAdd, ...subQuestionIds];
      }
  
      const alreadySelected = questionIdsToAdd.every((id) => selectedQuestions.includes(id));
  
      if (alreadySelected) {
        return {
          selectedQuestions: selectedQuestions.filter((id) => !questionIdsToAdd.includes(id)),
        };
      } else {
        return {
          selectedQuestions: [...selectedQuestions, ...questionIdsToAdd],
        };
      }
    });
  };

  handleSelectAll = () => {
    const { selectAll, questions } = this.state;
    if (selectAll) {
      this.setState({ selectedQuestions: [], selectAll: false });
    } else {
      const allIds = questions.map((item) => item.question_id);
      this.setState({ selectedQuestions: allIds, selectAll: true });
    }
  };

  handleSelectMyQuestions = (e) => {
    const isChecked = e.target.checked;
    this.setState(
      {
        checked: isChecked,  
        selectedTeachers: isChecked ? sessionStorage.getItem("user_id") : null  
      },
      () => {
        this.fetchAllQuestions();  
      }
    );
  };

  handleStartDateChange = (event) => {
      const date = event.target.value;
      const formattedDate = date ? date.replace(/-/g, "") : null;
      this.setState({ selectedStartDate : formattedDate},
          () =>{
            this.fetchAllQuestions();   
          }
      )
  };
    
  handleEndDateChange = (event) => {
      const date = event.target.value;
      const formattedDate = date ? date.replace(/-/g, "") : null;
      this.setState({ selectedEndDate : formattedDate},
          () => {
            this.fetchAllQuestions();  
          }
      )
  };

  clearDateRange = () => {
      this.setState({ selectedStartDate : "", selectedEndDate : "" },
        () =>{
          this.setState({ selectedStartDate : null, selectedEndDate : null },
            () => {
              this.fetchAllQuestions();  
            }
          );
        }
      );
  };

  //Rendering the necessary components based on the logic
  render() {
    const {
      limit,
      questions,
      totalCount,
      isTableDataLoading,
      currentPage,
      isLoading,
      selectedQuestions,
      selectAll
    } = this.state;
    
    this.validator.purgeFields();

    return (
      <>
        <ContentWrapper>
          <div className="row justify-content-between align-items-center py-5 mb-3">
            <div className="col-md-6 col-6">
              <h3 className="text-nowrap">Manage All Question Details</h3>
            </div>
          </div>
          <div className="thepapers-wrapper">
            <div className="col-md-12 px-0">
              <div className="row mt-6">
                                    <div className={`${
                                      this.state.isFilterCollapsed ? "col-md-1" : "col-md-3"
                                    } px-0 transition-width`}
                                    >
                                      <div className="filter-container">
                                        <div className={`${
                                              this.state.isFilterCollapsed
                                                 ? "collapsed-filter"
                                                     : "expanded-filter"
                                                               } filter-dynamic`}
                                                             >
                                                               <div className="d-flex flex-column flex-md-row flex-wrap align-items-stretch align-items-md-center justify-content-between w-100 gap-2">
                                                                 {/* Filters label shows when collapsed */}
                                                                 <span
                                                                   className={`${
                                                                     this.state.isFilterCollapsed ? "d-block" : "d-none"
                                                                   } filter-title`}
                                                                 >
                                                                   Filters
                                                                 </span>
                                                                 <IconButton
                                                                   onClick={() =>
                                                                     this.setState((prev) => ({
                                                                       ...prev,
                                                                       isFilterCollapsed: !prev.isFilterCollapsed,
                                                                     }))
                                                                   }
                                                                 >
                                                                   {this.state.isFilterCollapsed ? (
                                                                     <ChevronRightIcon />
                                                                   ) : (
                                                                     <ChevronLeftIcon />
                                                                   )}
                                                                 </IconButton>
                                                               </div>
                                                             </div>
                                     
                                                             {/* PaperFilterLayout goes here  */}
                                                              <div className="col-md-12 px-0 filterBySec"style={{display: this.state.isFilterCollapsed ? "none" : "block" }}>
                                                               <div className="col-md-12 px-0 filterBySec ">
                                                                 <PaperFilterLayout
                                                                   userType={"MASAD"}
                                                                   onFilterChange={this.handleFilterChange}
                                                                   filterKeys={EMPLOYEE_FILTERS.MASAD.ManageQuestions}
                                                                   isShowExamStatus={false}
                                                                />
                                                              </div>
                                                      </div>
                                                 
                                      </div>                      
                                    </div>
                  <div className={`${
                        this.state.isFilterCollapsed ? "col-md-11" : "col-md-9"
                      } transition-width`}
                    >
                  
                  
                    {/* <div style={{ display: 'inline-flex', alignItems: 'center', marginBottom: '10px' }}>
                      <input
                        type="checkbox"
                        id="selectMyQuestions"
                        onChange={this.handleSelectMyQuestions}
                        checked={this.state.checked}
                        style={{ marginRight: '8px' }}  
                      />
                      <label htmlFor="selectMyQuestions" style={{ margin: 0, cursor: 'pointer' }}>
                        My Questions
                      </label>
                    </div> */}
                    <StickyCardBody>
                      <div className="row align-items-center">
                        {/* Right side (Search box) */}
                        <div className="col-auto">
                          <Form.Group controlId="exampleForm.ControlInput1" style={{ width: "300px" }}>
                            <Form.Control
                              type="text"
                              placeholder="Search"
                              onChange={this.handleSearch}
                              isInvalid={this.state.searchError}
                            />
                            {this.state.searchError && (
                              <Form.Control.Feedback type="invalid">
                                Invalid input
                              </Form.Control.Feedback>
                            )}
                          </Form.Group>
                        </div>
                         
                        <div className="col d-flex align-items-center">
                          <Chip
                            label={
                              <span style={{ fontSize: "1.3rem" }}>
                                No of Questions:{" "}
                                <strong>
                                  {this.state.isTableDataLoading ? (
                                    <CircularProgress size={16} />
                                  ) : (
                                    this.state.totalRealCount
                                  )}
                                </strong>
                              </span>
                            }
                            variant="outlined"
                            color="primary"
                          />
                        </div>
                      </div>

                      <div className="col-md-3 d-flex justify-content-end">
                      {this.state.selectedQuestions.length > 0 && 
                        <Button
                          onClick={() => this.toggleUpdateBulkquestionModal()}
                          className="btn btn-primary btn-sm m-2" 
                          title="Select an/all questions to update Selected questions"
                          disabled={this.state.selectedQuestions.length === 0 ? true : false} 
                        >
                          Update All Selected questions
                        </Button>
                      }
                    </div>
                    </StickyCardBody>
                  
                  {isLoading && (
                    <PageSpinner id="show" text="Loading, Please wait!" />
                  )}
                  {isTableDataLoading ? (
                    <div
                      className="loading-container"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "75vw",
                        height: "90vh",
                      }}
                    >
                      <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                      </Spinner>
                    </div>
                  ) : questions.length > 0 ? (
                  <div className="row">
                    <div style={{ width: "80vw", height: "90vh", overflow: "auto" }}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>
                              <div style={{ display: "flex", alignItems: "center" }}>
                              <Checkbox
                                  checked={selectAll}
                                  onChange={this.handleSelectAll}
                                  color="primary"
                              />
                              <span>Select All</span>
                              </div>
                            </TableCell>
                            <TableCell
                              className="thead"
                              style={{ cursor: "pointer" }}
                              onClick={() => this.handleSortChange("question_id")}
                            >
                              Question Code{" "}
                              {this.state.sort_column === "question_id" && (
                              <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                              )}
                            </TableCell>
                            <TableCell
                              className="thead"
                              style={{ cursor: "pointer" }}
                              onClick={() => this.handleSortChange("qtype")}
                            >
                              Question Type{" "}
                              {this.state.sort_column === "qtype" && (
                              <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                              )}
                            </TableCell>
                            <TableCell
                              className="thead"
                              style={{ cursor: "pointer" }}
                              onClick={() => this.handleSortChange("grade_id")}
                            >
                              Question {gradeText}{" "}
                              {this.state.sort_column === "grade_id" && (
                              <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                              )}
                            </TableCell>
                            <TableCell
                              className="thead"
                              style={{ cursor: "pointer" }}
                              onClick={() => this.handleSortChange("subject_id")}
                            >
                              Question Subject{" "}
                              {this.state.sort_column === "subject_id" && (
                              <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                              )}
                            </TableCell>
                            {/* <TableCell
                              className="thead"
                              style={{ cursor: "pointer" }}
                              onClick={() => this.handleSortChange("chapter_id")}
                            >
                              Question Chapter{" "}
                              {this.state.sort_column === "chapter_id" && (
                              <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                              )}
                            </TableCell> */}
                            <TableCell className="thead">Actions</TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {questions.map((questionItem) => (
                            <TableRow key={questionItem.question_id}>
                              {questionItem.is_subquestion != "true"  ? 
                                  <TableCell>
                                      <Checkbox
                                      checked={selectedQuestions.includes(questionItem.question_id)}
                                      onChange={() => this.handleSelect(questionItem.question_id, questionItem.sub_questions)}
                                      color="primary"
                                      />
                                  </TableCell> :
                                  <TableCell></TableCell>
                              }
                              <TableCell className="tData">
                                {'QUSTN' + questionItem.question_id}
                              </TableCell>
                              <TableCell className="tData">
                                {this.getQuestionType(questionItem.qtype, questionItem.is_subquestion)}
                              </TableCell>
                              <TableCell className="tData">
                                {this.getQuestionGrade(questionItem.grade_id)}
                              </TableCell>
                              <TableCell className="tData">
                                {this.getQuestionSubject(questionItem.subject_id)}
                              </TableCell>
                              {/* <TableCell className="tData">
                                {this.getQuestionChapter(questionItem.chapter_id)}
                              </TableCell> */}
                              <TableCell>
                                <div className="btn-group">
                                  <Button
                                    onClick={() => this.handleViewClick(questionItem)}
                                    className="btn btn-icon btn-primary btn-sm m-1 view-assement-btn flaticon-eye-icon"
                                    title="View More Details"
                                  />
                                </div>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      <MaterialCustomTablePagination
                        totalCount = {totalCount}
                        currentPage = {currentPage}
                        limit = {limit}
                        handlePageChange = {this.handlePageChange}
                        handleRowsPerPageChange = {this.handleRowsPerPageChange}
                        handlePageOffsetChange = {this.handlePageOffsetChange}
                        offset = {this.state.offset}
                        rowsPerPageOptions={[5, 10, 20, 25, 50, 75, 100, 150, 200, 250, 300]}
                      />
                    </div>
                  </div>
                  ) : (
                    <div className="row">
                      <div style={{ width: "80vw", height: "90vh", overflow: "auto" }}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell className="thead">Question Type</TableCell>
                              <TableCell className="thead">Question {gradeText}</TableCell>
                              <TableCell className="thead">Question Subject</TableCell>
                              <TableCell className="thead">Question Chapter</TableCell>
                              <TableCell className="thead">Actions</TableCell>
                            </TableRow>
                          </TableHead>
                        </Table>
                        <div className="text-center mb-5 my-10">
                          <label>No questions are available!</label>
                        </div>
                      </div>
                    </div>
                  )}
                
              </div>
              </div>
            </div>
          </div>
        </ContentWrapper>

        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.showUpdateBulkDetailModal}
          onHide={this.toggleUpdateBulkquestionModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>Update Details for All Selected questions</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="my-5">
                <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput1"
                >
                <Form.Label>Enter Common Title</Form.Label>
                <Form.Control
                    type="text"
                    id="edit-Question-title"
                    value={this.state.editTitle}  // Assuming the state holds the input value as 'editCategoryName'
                    onChange={this.handleChangeTitle}  // Method to handle input change
                    className="form-control"
                />
                <Form.Label>Update Category</Form.Label>
                <Form.Select
                    id="edit-Question-category"
                    value={this.state.editCategoryId}
                    onChange={this.handleChangeCategory}
                    className="form-control"
                    >     
                    <option value={null}>Nothing Selected</option>
                    {this.state.allCategories.map((option, index) => (
                        <option key={index} value={option.category_id}>
                          {option.name}
                        </option>
                    ))}
                </Form.Select>
                <Form.Label>Update {gradeText}</Form.Label>
                <Form.Select
                    id="edit-Question-grade"
                    value={this.state.editGradeId}
                    onChange={this.handleChangeGrade}
                    className="form-control"
                    >     
                    <option value={null}>Nothing Selected</option>
                    {this.state.allGrades.map((option, index) => (
                        <option key={index} value={option.grade_id}>
                          {option.grade}
                        </option>
                    ))}
                </Form.Select>
                <Form.Label>Update Language</Form.Label>
                <Form.Select
                    id="edit-Question-language"
                    value={this.state.editLanguageId}
                    onChange={this.handleChangeLanguage}
                    className="form-control"
                    >     
                    <option value={null}>Nothing Selected</option>
                    {this.state.allLanguages.map((option, index) => (
                        <option key={index} value={option.language_id}>
                          {option.language}
                        </option>
                    ))}
                </Form.Select>
                <Form.Label>Update Chapter/Module/Unit</Form.Label>
                <Form.Select
                    id="edit-Question-chapter"
                    value={this.state.editChapterId}
                    onChange={this.handleChangeChapter}
                    className="form-control"
                    >
                    <option value={null}>Nothing Selected</option>
                    {this.state.allChapters.map((option, index) => (
                        <option key={index} value={option.chapter_id}>
                          {option.chapter}
                        </option>
                    ))}
                </Form.Select>
                <Form.Label>Update Subject</Form.Label>
                <Form.Select
                    id="edit-Question-subject"
                    value={this.state.editSubjectId}
                    onChange={this.handleChangeSubject}
                    className="form-control"
                    >
                    <option value={null}>Nothing Selected</option>
                    {this.state.allSubjects.map((option, index) => (
                        <option key={index} value={option.subject_id}>
                          {option.subject}
                        </option>
                    ))}
                </Form.Select>
                <Form.Label>Update Difficulty</Form.Label>
                <Form.Select
                    id="edit-Question-difficulty"
                    value={this.state.editDifficultyId}
                    onChange={this.handleChangeDifficulty}
                    className="form-control"
                    >
                    <option value={null}>Nothing Selected</option>
                    {this.state.allDifficulties.map((option, index) => (
                        <option key={index} value={option.difficulty_id}>
                          {option.difficulty_type}
                        </option>
                    ))}
                </Form.Select>
                <Form.Label>Update Author</Form.Label>
                <Form.Select
                    id="edit-Question-author"
                    value={this.state.editAuthorId}
                    onChange={this.handleChangeAuthor}
                    className="form-control"
                    >
                    <option value={null}>Nothing Selected</option>
                    {this.state.allAuthors.map((option, index) => (
                        <option key={index} value={option.author_id}>
                          {option.author}
                        </option>
                    ))}
                </Form.Select>
                <Form.Label>Update Source</Form.Label>
                <Form.Select
                    id="edit-Question-author"
                    value={this.state.editSourceId}
                    onChange={this.handleChangeSource}
                    className="form-control"
                    >
                    <option value={null}>Nothing Selected</option>
                    {this.state.allSources.map((option, index) => (
                        <option key={index} value={option.source_id}>
                          {option.source}
                        </option>
                    ))}
                </Form.Select>
                <Form.Label>Update Year</Form.Label>
                <Form.Select
                    id="edit-Question-year"
                    value={this.state.editYearId}
                    onChange={this.handleChangeYear}
                    className="form-control"
                    >
                    <option value={null}>Nothing Selected</option>
                    {this.state.allYears.map((option, index) => (
                        <option key={index} value={option.year_id}>
                          {option.year}
                        </option>
                    ))}
                </Form.Select>
                <Form.Label>Update Term/Semester</Form.Label>
                <Form.Select
                    id="edit-Question-term"
                    value={this.state.editTermId}
                    onChange={this.handleChangeTerm}
                    className="form-control"
                    >
                    <option value={null}>Nothing Selected</option>
                    {this.state.allTerms.map((option, index) => (
                        <option key={index} value={option.term_id}>
                          {option.term}
                        </option>
                    ))}
                </Form.Select>
                {privilegeEditEnabled && (
                  <>
                  <Form.Label>Update Privilege</Form.Label>
                  <Form.Select
                      id="edit-Question-privilege"
                      value={this.state.editPrivilegeId}
                      onChange={this.handleChangePrivilege}
                      className="form-control"
                      >
                      <option value={null}>Nothing Selected</option>
                      {this.state.allPrivileges.map((option, index) => (
                          <option key={index} value={option.privilege_id}>
                            {option.privilege}
                          </option>
                      ))}
                  </Form.Select>
                </>
                )}
                </Form.Group>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="modal-btn"
              variant="primary"
              style={addBtnStyle}
              onClick={this.handleUpdateBulkSubmit}
            >
              Save changes
            </Button>
            <Button
              className="modal-btn"
              id="modal-close-button"
              style={closeBtnStyle}
              onClick={this.handleBulkClose}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          size="lg"
          centered
          show={this.state.showDetailModal}
          onHide={this.toggleDetailModal}
        >
          <ModalHeader>
            <h5 className="modal-title">{this.state.selectedQuestion?.title}</h5>
            <Button variant="secondary" onClick={this.toggleDetailModal}>
              Close
            </Button>
          </ModalHeader>
          {this.state.selectedQuestion && (
          <ModalBody>
            <ViewForm className="form" id="kt_form">
             {this.state.selectedQuestion?.qtype !== null && 
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Type :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getQuestionType(this.state.selectedQuestion?.qtype, this.state.selectedQuestion?.is_subquestion)}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div>
                </>
              }     
              {this.state.selectedQuestion?.category_id !== null && 
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Category :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getQuestionCategory(this.state.selectedQuestion?.category_id)}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div>
                </>
              }     
              {this.state.selectedQuestion?.language_id !== null && 
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Language :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getQuestionLanguage(this.state.selectedQuestion?.language_id)}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div>
                </>
              }
              {this.state.selectedQuestion?.difficulty_id !== null && 
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Difficulty :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getQuestionDifficulty(this.state.selectedQuestion?.difficulty_id)}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div>
                </>
              }
              {this.state.selectedQuestion?.subject_id !== null && 
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Subject :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getQuestionSubject(this.state.selectedQuestion?.subject_id)}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div>
                </>
              }
              {this.state.selectedQuestion?.chapter_id !== null && 
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Chapter/Module/Unit :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getQuestionChapter(this.state.selectedQuestion?.chapter_id)}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div> 
                </>
              }
              {this.state.selectedQuestion?.author_id !== null &&
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Author :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getQuestionAuthor(this.state.selectedQuestion?.author_id)}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div>
                </>
              }
              {this.state.selectedQuestion?.source_id !== null &&
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Source :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getQuestionSource(this.state.selectedQuestion?.source_id)}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div>
                </>
              }
              {this.state.selectedQuestion?.year_id !== null && !isCMC &&
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Year :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getQuestionYear(this.state.selectedQuestion?.year_id)}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div>
                </>
              }
              {this.state.selectedQuestion?.term_id !== null && 
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Term/Semester :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getQuestionTerm(this.state.selectedQuestion?.term_id)}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div>
                </>
              }
              {this.state.selectedQuestion?.first_name !== null && this.state.selectedQuestion?.last_name !== null && 
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Created By :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.state.selectedQuestion?.first_name + " " + this.state.selectedQuestion?.last_name}
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-5"></div>
                </>
              }
              {this.state.selectedQuestion?.created_at !== null && 
                <>
                  <div className="row">
                    <h6 className="font-weight-bolder mb-3 col-md-4">
                      Created At :
                    </h6>
                    <div className="text-dark-50 line-height-lg col-md-5">
                      <div className="inline-flex full-width align-center">
                        {this.getCreatedAtLocal(this.state.selectedQuestion?.created_at)}
                      </div>
                    </div>
                  </div>
                </>
              }
            </ViewForm>
          </ModalBody>
          )}
        </Modal>
      </>
    );
  }
}
